import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { PoaRequiredModalComponent } from './components/poa-required-modal/poa-required-modal.component';

@NgModule({
  declarations: [PoaRequiredModalComponent],
  imports: [CommonModule, TranslateModule, CustomModalModule],
  exports: [PoaRequiredModalComponent],
})
export class PoaRequiredModalModule {}
